import { useEffect, useRef, useState, type ReactNode } from 'react';

// Başlangıç konumu: hangi yönden kayarak gireceği.
//   'up'    → alttan yukarı, hafif (varsayılan)
//   'rise'  → alttan yukarı, belirgin (alt kart üste geliyormuş hissi)
//   'left'  → soldan sağa
//   'right' → sağdan sola
type From = 'up' | 'rise' | 'left' | 'right';

const HIDDEN: Record<From, string> = {
  up: 'translate-y-6 opacity-0',
  rise: 'translate-y-16 opacity-0',
  left: '-translate-x-10 opacity-0',
  right: 'translate-x-10 opacity-0',
};

// Kaydırınca beliren (fade/slide) sarmalayıcı — bağımlılıksız IntersectionObserver.
const Reveal = ({
  children,
  delay = 0,
  className = '',
  from = 'up',
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
  from?: From;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      // Biraz daha geç tetikle: öğe görünüm alanına ~%10 girdiğinde animasyon
      // başlasın ki kayma (slide) hareketi belirgin görünsün, alt kenarda
      // anında "açılmış" gibi olmasın.
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`transition-all duration-700 ease-in-out ${
        shown ? 'translate-x-0 translate-y-0 opacity-100' : HIDDEN[from]
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Reveal;
